import { render, staticRenderFns } from "./ActivityConfig.vue?vue&type=template&id=55f92ee8&scoped=true"
import script from "./ActivityConfig.vue?vue&type=script&lang=js"
export * from "./ActivityConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f92ee8",
  null
  
)

export default component.exports